import { createContext, Dispatch, SetStateAction } from 'react'

export interface ToppingContextData {
  topping: ItemTopping
  setTopping: Dispatch<SetStateAction<ItemTopping>>
}

export const ToppingContext = createContext<ToppingContextData>({} as ToppingContextData)
